// import logoLabeler from '@Cyclope-Assets/images/logo/tunnelwatch.png';

import * as React from "react";
import * as Paths from "@tunnel-enums/index";
import { Link } from "react-router-dom";
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { message, emptyIncident } = props;
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-router-dom
   * @infos "https://reactjs.org"
   */
  return (
    <div className="maintenance animated fadeIn">
      <div className="ml_maintenance">
        <div className="ml_clearRoad">
          <div className="message-empty-incident">
            <p>{message}</p>
            {emptyIncident && (
              <div className="btn-explore">
                <Link to={{ pathname: Paths.PathsNamesEnums.EXPLORE }}>
                  <p style={{ display: "block", width: "100%" }}>
                    <span className="borderGradian">
                      <span
                        className="btnSecondary "
                        style={{
                          backgroundColor: "white",
                          overflow: "visible",
                        }}
                      >
                        <span className="textGradianlarge">
                          {i18next.t("acceder aux evenements termines")}
                        </span>
                      </span>
                    </span>
                  </p>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onAddInhibition?: any;
  message?: any;
  emptyIncident?: boolean;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/message/component.tsx